package team.platforma.dictionary_presentation.model

data class AiModelPresentation(
   val id : Long,
   val name : String,
   val chapter : Long,
   val description : String,
   val cover : String?
)
